export enum HttpMethod {
    PUT = 'put',
    POST = 'post',
    GET = 'get',
    DELETE = 'delete',
    PATCH = 'patch',
    HEAD = 'head',
    OPTIONS = 'options',
    CONNECT = 'connect',
    TRACE = 'trace'
}
